module.exports = __webpack_public_path__ + "img/ico-whatsapp-circle.ca6e9b9b.svg";